(function initializeStoreRoutePreview(root, factory) {
  const api = factory();

  if (typeof module === 'object' && module.exports) {
    module.exports = api;
  }

  if (root) {
    root.StoreRoutePreview = api;
  }
})(typeof globalThis !== 'undefined' ? globalThis : this, () => {
  const ROUTING_ENDPOINTS = {
    driving: 'https://routing.openstreetmap.de/routed-car/route/v1/driving',
    walking: 'https://routing.openstreetmap.de/routed-foot/route/v1/walking',
  };

  function isPoint(value) {
    return (
      value &&
      Number.isFinite(value.latitude) &&
      value.latitude >= -90 &&
      value.latitude <= 90 &&
      Number.isFinite(value.longitude) &&
      value.longitude >= -180 &&
      value.longitude <= 180
    );
  }

  function normalizeMode(mode) {
    return mode === 'walking' ? 'walking' : 'driving';
  }

  function buildRouteUrl(origin, destination, mode = 'driving') {
    if (!isPoint(origin) || !isPoint(destination)) return '';

    const normalizedMode = normalizeMode(mode);
    const coordinates = `${origin.longitude},${origin.latitude};${destination.longitude},${destination.latitude}`;

    return `${ROUTING_ENDPOINTS[normalizedMode]}/${coordinates}?overview=full&geometries=geojson&steps=false`;
  }

  function parseRoute(payload) {
    const route = payload?.code === 'Ok' ? payload.routes?.[0] : null;
    const coordinates = route?.geometry?.coordinates;
    const validCoordinates =
      Array.isArray(coordinates) &&
      coordinates.length >= 2 &&
      coordinates.every(
        (coordinate) =>
          Array.isArray(coordinate) &&
          coordinate.length >= 2 &&
          Number.isFinite(coordinate[0]) &&
          Number.isFinite(coordinate[1])
      );

    if (!validCoordinates) return null;

    return {
      geometry: {
        type: 'LineString',
        coordinates,
      },
      distanceMeters: Number.isFinite(route.distance) ? route.distance : null,
      durationSeconds: Number.isFinite(route.duration) ? route.duration : null,
    };
  }

  function formatDuration(durationSeconds) {
    if (!Number.isFinite(durationSeconds) || durationSeconds <= 0) return '';

    const totalMinutes = Math.max(1, Math.round(durationSeconds / 60));
    if (totalMinutes < 60) {
      return `${totalMinutes} ${totalMinutes === 1 ? 'min' : 'mins'}`;
    }

    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    const hourLabel = `${hours} ${hours === 1 ? 'hr' : 'hrs'}`;

    return minutes === 0 ? hourLabel : `${hourLabel} ${minutes} mins`;
  }

  return {
    buildRouteUrl,
    formatDuration,
    normalizeMode,
    parseRoute,
  };
});
